import { useMutation } from "react-query";
import { deleteOwners } from "~/components/Forms/DealerPassportForm2/requests/deleteOwners";

export default function useDeleteOwners() {
  return useMutation({
    mutationFn: ({
      dealerId,
      ownerId,
    }: {
      dealerId: string;
      ownerId: number;
    }) => deleteOwners(dealerId, ownerId),
  });
}
